import { IDoctorInfo } from './doctor';

export interface IOrderAndDoctorInfo {
  orderInfo: IOrderInfo;
  doctorInfo: IDoctorInfo;
  prescriberOrderInfo?: IPrescriptOrderInfo;
}

// 订单信息
export interface IOrderInfo {
  createTime: string; // 订单创建时间
  finishTime?: string; // 订单结束时间
  reserveTime?: string; // 电话问诊预约时间
  doctorId: number; //  医生快手ID
  id: number; // 订单ID
  orderStatus: ORDER_STATUS; // 订单状态
  paymentAmount: number; // 订单支付金额 接口单位是[分]
  couponAmount: number; // 使用优惠券金额 接口单位是[分]
  productAmount: number; // 产品金额 接口单位是[分]
  productName: string; // 产品名称
  productType: PRODUCT_TYPE; // 产品类型: 0图文|1极速回复|2免费咨询
  orderState: OrderState; // 前端订单状态区分使用 2021-03-02 问诊服务变更新增
  userId?: number; // 用户快手 ID
  questionDetailInformation: IQuestionDetail;
  doctorAnswer?: DOCTOR_ANSWER; // 是否回复: 0未回复|1已经回复，医生已接单变为1
  userEvaluated?: USER_COMMENT; // 患者是否评价
  sentEnd?: END_NOTICE; // 是否发送过订单结束系统消息提示 0未发送|1已发送
  payComplete?: PayCompleteFlag; // 是否完成支付：0未完成|1已完成
  refundStatus?: RefundStatus; // 退款状态：0-未申请|1-退款审核中|2-退款驳回|3-退款中|4-已退款|5-退款失败
  checkRefund?: boolean; // 是否允许申请退款: false-不允许，true-允许
  acceptTime?: string | null; // 医生接单时间
  payTime?: string | null;
  // 挂号相关参数
  hospitalName?: string; // 挂号医院
  reserveDate?: string; // 挂号订单日期
  registeredReserveTime?: string; // 挂号订单预约时间
  registrationFeeInterval?: string; // 挂号价格 区间或固定价格
  updateTime?: string; // 订单取消时间

  unreadCount?: number;
  freeReply?: number; // -1不可赠送，0可赠送，1已赠送

  prescriptionId?: number; // 处方ID
  prescriptionStatus?: PRESCRIPT_STATUS; // 处方状态
  groupId: string; // 群聊id
  departmentId: number;
  departmentName: string;
}

// 开方订单信息
export interface IPrescriptOrderInfo {
  createTime: string; // 订单创建时间
  acceptTime: string; // 医生接单时间
  finishTime: string; // 订单结束时间
  payTime: string; // 用户支付时间
  updateTime: string; // 更新时间

  id: number; // 咨询订单ID
  userId: number; // 用户快手ID
  doctorId: number; // 医生快手ID
  prescriberId: number; // 开方医生快手ID
  prescriptionId: number; // 处方ID
  payComplete: number; // 是否完成支付：0未完成|1已完成
  doctorName: string; // 医生名称

  paymentAmount: number; // 支付金额
  productAmount: number; // 产品金额
  productName: string; // 产品名称

  productType: number; // 产品类型: 0图文|1极速回复|2免费咨询
  questionDetailInformation: IQuestionDetail; // 患者和病情信息

  orderStatus: ORDER_STATUS; // 问诊订单状态
  prescriptionStatus: PRESCRIPT_STATUS; // 处方状态
  prescriptionDesignatingStatus: PRESCRIPT_ORDER_STATUS; // 处方订单状态
  unreadCount: number; // 未读消息个数
  groupId?: string; // 群聊id
}

// 问诊描述信息
export interface IQuestionDetail {
  conditionDescription: string; // 病情描述
  diseasePictures: string[]; // 疾病图片
  offlineSeenDoctor: boolean; // 是否线下看过医生
  patientVo: IPatientInfo; // 患者信息
}

// 患者信息
export interface IPatientInfo {
  currentCity: string; // 患者当前所在城市
  id: number; // 患者ID，更新信息时需传此参数
  patientAge: number; // 患者年龄
  patientGender: number; // 患者性别: 0女性|1男性
  patientMobile: string; // 患者手机号
  patientName: string; // 患者名称
  userId: number; // 用户快手ID
}

// 患者评价信息
export interface ICommentInfo {
  commentContent: string;
  starLevel: number;
  tagContents: string[];
}

// 订单状态
export enum ORDER_STATUS {
  Initial = 100, // 初始化 取消此状态码
  HasPaid = 200, // 已支付,医生未接诊
  Consulting = 300, // 已接诊,沟通中
  HasConsulted = 400, // 已完成
  // Settlementting = 500, // 结算中
  // Settlemented = 600 // 已结算, 可提现
  // HasRefunded = 700, // 退款结束
  // CanWithdrawal = 800 // 已结算可提现
  Canceled = 500, // 已关闭
  RegisterCanceled = 700, // 正常结束的线下支付挂号订单, 挂号订单特有
  RegisterProcessing = 120, // 预约处理中
  CancelRegisterProcessiong = 320 // 退号处理中
}

// 开方派单状态
export enum PRESCRIPT_ORDER_STATUS {
  NotAccept = 0, // 待接单
  NotPrescript = 100, // 接单待开方
  HasPrescript = 200, // 已开方
  AcceptTimeout = 300, // 未在规定时间内接单
  PrescriptTimeout = 400, // 未在规定时间内完成开方
  Complete = 500 // 已开方且咨询订单结束
}

// 处方状态
export enum PRESCRIPT_STATUS {
  INIT = 0, // 预开放初始化
  AUDITING = 200, // 开方待审
  AUDIT_PASS = 300, // 审核通过，退款未失效
  AUDIT_FAIL = 400, // 审核拒绝
  CANCEL = 500, // 已取消
  EXPIRED = 600, // 已过期，退款已失效
  USED = 700 // 已使用
}

// 弹窗类型
export enum AGREEMENT_TYPE {
  Message,
  Call,
  Free,
  Register = 5,
  QuickConsult = 6,
  SkinConsult = 7,
  GroupChat = 8,
  NucleicAcidTest = 9
}

// 产品类型
export enum PRODUCT_TYPE {
  Message,
  Call,
  Free,
  Register = 5,
  QuickConsult = 6,
  SkinConsult = 7,
  Report = 8,
  Survey = 9,
  MedConsult = 10
}

// 产品类型描述
export enum PRODUCT_TYPE_DESC {
  Message = '图文咨询',
  Call = '电话咨询',
  Free = '免费咨询',
  Register = '挂号',
  QuickConsult = '极速咨询',
  SkinConsult = '拍照测肤',
  Report = '报告解读',
  Survey = '健康自测',
  MedConsult = '用药咨询'
}

// 产品类型与弹窗类型映射关系
export const PRODUCT_AGREEMENT_MAP = {
  [PRODUCT_TYPE.Message]: AGREEMENT_TYPE.Message,
  [PRODUCT_TYPE.Call]: AGREEMENT_TYPE.Call,
  [PRODUCT_TYPE.Free]: AGREEMENT_TYPE.Free,
  [PRODUCT_TYPE.Register]: AGREEMENT_TYPE.Register,
  [PRODUCT_TYPE.QuickConsult]: AGREEMENT_TYPE.QuickConsult,
  [PRODUCT_TYPE.SkinConsult]: AGREEMENT_TYPE.SkinConsult
};

// 分诊产品类型
export enum QUICKCONSULT_TYPE {
  QuickConsult = 1,
  SkinConsult = 2
}

export enum QUICKCONSULT_TYPE_DESC {
  QuickConsult = '极速咨询',
  SkinConsult = '拍照测肤'
}

// 产品类型
export enum PRODUCT_TYPE_AD {
  Message = '24小时不限次数，图文沟通咨询',
  Call = '15分钟电话沟通，24小时不限次数图文沟通',
  Free = '24小时不限次数，图文沟通咨询'
}

// 全职医生描述
export enum PRODUCT_TYPE_AD_FULLTIME {
  Message = '2小时不限次数，图文沟通咨询',
  Call = '15分钟电话沟通，24小时不限次数图文沟通',
  Free = '24小时不限次数，图文沟通咨询'
}

// 医生是否回复
export enum DOCTOR_ANSWER {
  notAnswer,
  hasAnswer,
  rejectAnswer
}

// 患者是否评价:0未评价|1已评价
export enum USER_COMMENT {
  notComment,
  hasComment
}

export interface IUnreadMsg {
  orderId: number;
  orderStatus: ORDER_STATUS;
  unreadCount: number;
}

// 未读消息存储
export interface IMapUnread {
  [key: number]: number;
}

// 是否发送过订单结束消息: 0未发送|1已发送
export enum END_NOTICE {
  notSend,
  hasSend
}

export enum CREATE_ORDER_STATUS {
  Create,
  Self = -5,
  NoData = 3000,
  InOrder = 3001,
  NotPay = 3004
}

export interface ISupportOrder {
  // 0 "可以下单"
  // -5,"医生不能给自己下单"
  // 3000, "健康咨询根据医生ID获取医生信息为空"
  // 3001, "存在未结束的咨询订单"
  // 3004, "存在未支付的咨询订单"
  conditionValue: CREATE_ORDER_STATUS;
  message: string;
  orderId?: number;
}
export interface IPatientObj {
  activeTime: number;
  age: number;
  avatarUr: string;
  gender: string;
  latestMsgPreview?: string;
  targetId: number;
  targetName: string;
  unreadCount: number;
  communicatingFlag: boolean;
  productType?: number;
}

// 医生端健康咨询页tab切换，0咨询记录，1消息列表
export enum TabType {
  records,
  message
}

// 280支付成功：待预约
// 300三方订单创建完成：待体检
// 400订单正向履约完成：体检完成
// 600取消订单成功
// 700申请退款中： 退款中
// 800退款成功：退款完成
export enum COVID_ORDER_STATUS_TYPE {
  ALL = 0,
  TODO = 280,
  BOOKED = 300,
  COMPLETE = 400,
  CANCEL_SUCCESS = 600,
  REFUND_APPLIED = 700,
  REFUND_SUCCESS = 800,
  REFUND_FAIL = 750
}

export const COVID_ORDER_STATUS = {
  [COVID_ORDER_STATUS_TYPE.TODO]: '待预约',
  [COVID_ORDER_STATUS_TYPE.BOOKED]: '待体检',
  [COVID_ORDER_STATUS_TYPE.COMPLETE]: '已完成',
  [COVID_ORDER_STATUS_TYPE.CANCEL_SUCCESS]: '待预约',
  [COVID_ORDER_STATUS_TYPE.REFUND_SUCCESS]: '退款完成',
  [COVID_ORDER_STATUS_TYPE.REFUND_APPLIED]: '退款中',
  [COVID_ORDER_STATUS_TYPE.REFUND_FAIL]: '退款失败'
};

export interface IOrderDteailInfo {
  createTime: string;
  orderNo: string;
  orderStatus: number;
  paymentAmount: string;
  paymentOrderNo: string;
  paymentTime: string;
  totalAmount: string;
}

interface IOrderDetailPersonInfo {
  appointEndDate: string;
  appointStartDate: string;
  idCard: string;
  mobile: string;
  name: string;
}

export interface IOrderDetailRefundInfo {
  refundAmount: string;
  refundSuccessTime: string;
  refundTime: string;
}

interface IOrderDetailStoreInfo {
  productAmount: string;
  serviceProvider: string;
  storeAddress: string;
  storeIcon: string;
  storeName: string;
  storeTel: string;
  svcName: string;
  validUntil: string;
}
export interface ICovid19OrderDetail {
  instructionList: string[];
  mobile: string;
  orderInfo: IOrderDteailInfo;
  personInfo: IOrderDetailPersonInfo;
  refundInfo: IOrderDetailRefundInfo;
  storeInfo: IOrderDetailStoreInfo;
}

// 退款状态
export enum RefundStatus {
  NoApply,
  Checking,
  Reject,
  Checked,
  Refunding,
  Success,
  Fail
}

export enum PayCompleteFlag {
  NotDone,
  Success
}

// 2021-03-02 订单新状态
export enum OrderState {
  noPay, // 0-已下单,未支付
  hasPaid, // 1-已支付
  hasDoctorReplay, // 2-医生已回复, 沟通中
  completeNoRefund, // 3-沟通已结束, 不可退款
  consultCanceled, // 4-咨询取消
  completeCanRefund, // 5-沟通已结束,可退款
  refunding, // 6-退款中
  refunded, // 7-已退款
  refundCanceled, // 8-退款被驳回
  unKnow, // 9 未查询到的状态, 容错占位
  freeWaiting, // 免费订单等待中 orderStatus = 200
  freeConsulting, // 免费订单咨询中 orderStatus = 300
  freeCompleted, // 免费订单已结束状态 orderStatus = 400
  rejected, // 咨询被医生拒单
  freeDoctorNoAccept, // 免费订单&医生未接单
  doctorNoAcceptRefunding, // 收费订单&医生未接单，退款中
  doctorNoAcceptRefunded // 收费订单&医生未接单，已退款
}

// 支付中台ksBridge.startKspayOrderPrepay 支付后 complete 回调结果
export enum PAY_RESULT {
  Cancel, // 支付取消
  Success // 支付成功
}

export type TOrderValue = number | undefined;

// 用户是否可查看消息
export const canUserViewMessage = (
  orderStatus: TOrderValue,
  doctorAnswer: TOrderValue
) =>
  orderStatus === ORDER_STATUS.HasConsulted &&
  doctorAnswer === DOCTOR_ANSWER.hasAnswer;

// 用户是否可评价订单
export const canUserComment = (
  doctorAnswer: TOrderValue,
  userEvaluated: TOrderValue,
  orderStatus: TOrderValue
) =>
  orderStatus === ORDER_STATUS.HasConsulted &&
  doctorAnswer === DOCTOR_ANSWER.hasAnswer &&
  userEvaluated === USER_COMMENT.notComment;

// 用户是否可查看处方
export const canUserViewPrescript = (
  prescriptionId,
  prescriptionStatus: PRESCRIPT_STATUS | undefined
) =>
  prescriptionId &&
  (prescriptionStatus === PRESCRIPT_STATUS.AUDIT_PASS ||
    prescriptionStatus === PRESCRIPT_STATUS.USED);

// 医生是否可查看处方
export const canDoctorViewPrescript = (
  prescriptionId,
  prescriptionStatus: PRESCRIPT_STATUS | undefined
) =>
  prescriptionId &&
  prescriptionStatus != null &&
  prescriptionStatus !== PRESCRIPT_STATUS.INIT;

// 开方医师是否可开处方
export const canAssistantPrescript = (
  orderStatus: ORDER_STATUS | undefined,
  prescriptionDesignatingStatus: PRESCRIPT_ORDER_STATUS | undefined
) =>
  // 咨询中未接单、未开方
  (orderStatus === ORDER_STATUS.Consulting &&
    (prescriptionDesignatingStatus === PRESCRIPT_ORDER_STATUS.NotAccept ||
      prescriptionDesignatingStatus === PRESCRIPT_ORDER_STATUS.NotPrescript)) ||
  // 咨询结束未开方
  (orderStatus === ORDER_STATUS.HasConsulted &&
    prescriptionDesignatingStatus === PRESCRIPT_ORDER_STATUS.NotPrescript);

// 开方医师是否可查看处方
export const canAssistantViewPrescript = (
  prescriptionDesignatingStatus: PRESCRIPT_ORDER_STATUS | undefined
) =>
  prescriptionDesignatingStatus === PRESCRIPT_ORDER_STATUS.HasPrescript ||
  prescriptionDesignatingStatus === PRESCRIPT_ORDER_STATUS.Complete;

// 开方医师是否可查看消息
export const canAssistantViewMessage = (
  prescriptionDesignatingStatus: PRESCRIPT_ORDER_STATUS | undefined
) => prescriptionDesignatingStatus !== PRESCRIPT_ORDER_STATUS.NotAccept;

// 订单列表卡片按钮操作
export interface IAction {
  isShow: boolean; // 是否显示按钮
  actionName: string; // 按钮文案
  onClick: any; // 按钮触发操作
  actionStyle?: 'default' | 'primary'; // 按钮样式
  unread?: number; // 未读消息数
}

// 赠送回复次数：-1不可赠送，0可赠送，1已赠送
export const FreeReplay = {
  canGive: 0,
  gived: 1,
  cannotGive: -1
};

export type ILastConsultRecord = {
  createTime: string; // 订单创建时间
} & IQuestionDetail;

// 极速咨询页面query参数对应的
export const MapOfProdTypeCode = {
  medConsult: PRODUCT_TYPE.MedConsult,
  report: PRODUCT_TYPE.Report,
  quickConsult: PRODUCT_TYPE.QuickConsult,
  survey: PRODUCT_TYPE.Survey,
  skinConsult: PRODUCT_TYPE.SkinConsult
};

// 极速咨询页面query参数列表
export const QUERY_PRODTYPE = {
  [PRODUCT_TYPE.QuickConsult]: `quickConsult`,
  [PRODUCT_TYPE.SkinConsult]: `skinConsult`,
  [PRODUCT_TYPE.Report]: `report`,
  [PRODUCT_TYPE.MedConsult]: `medConsult`,
  [PRODUCT_TYPE.Survey]: `survey`
};
export interface IAssistantOrderListResult {
  lastMark: boolean;
  list: IPrescriptOrderInfo[];
  pageNum: number;
  pageSize: number;
  total: number;
}

// 咨询小结
export interface IConsultSummaryVo {
  id: number;
  orderId: number;
  conditionDescription?: string; // 患者主诉
  departmentId: number;
  departmentName: string;
  diagnosisRecommendations: string;
  diagnosisResult: string;
  patientAge: number;
  patientGender: number;
  patientName: string;
  createTime: string;
  updateTime: string;
  modifyStatus: boolean; // 是否可修改
}
export type TConsultSummaryKeyType =
  | 'conditionDescription'
  | 'departmentId'
  | 'departmentName'
  | 'diagnosisRecommendations'
  | 'diagnosisResult';

export type TConsultSummaryAdd = Pick<
  IConsultSummaryVo,
  TConsultSummaryKeyType | 'orderId'
>;

export type TConsultSummaryUpdate = Pick<
  IConsultSummaryVo,
  TConsultSummaryKeyType | 'id' | 'orderId'
>;

// 医生接、拒单时需要选择部门的订单类型
export const isDoctorNeedSelectDepartment = (productType: PRODUCT_TYPE) =>
  [
    PRODUCT_TYPE.QuickConsult,
    PRODUCT_TYPE.SkinConsult,
    PRODUCT_TYPE.Survey,
    PRODUCT_TYPE.Report,
    PRODUCT_TYPE.MedConsult
  ].includes(productType);
export interface ISavePreConsultInfoReqBody {
  conditionDescription: string;
  diseasePictures: string[];
  patientAge: number;
  patientGender: number;
  patientName: string;
}

export interface IPreConsultInfo {
  conditionDescription: string;
  diseasePictures: string[];
  patientAge: number;
  patientGender: number;
  patientName: string;
  cardUpdateFlag: boolean; // true: 需要更新卡片文案; false: 不需要更新卡片文案
  popUpFlag: boolean; // true: 需要弹窗; false: 不需要弹窗
}
